import { useQuery } from '@tanstack/react-query';

import { fetchComponent } from '../services/api/components';

export const useComponent = (componentId?: string) => {
  return useQuery({
    queryKey: ['component', componentId],
    queryFn: () => fetchComponent(componentId!),
    enabled: Boolean(componentId),
  });
};
